
import Vue from 'vue'

const locales = {keys(){return []}}
global['____0BBA027____'] = true;
delete global['____0BBA027____'];
global.__uniConfig = {"easycom":{"autoscan":true,"custom":{"^u-(.*)":"uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"tabBar":{"height":"64px","iconWidth":"33px","color":"#999","selectedColor":"#333333","borderStyle":"white","backgroundColor":"#f7f7f7","midButton":{"height":"76px","width":"60px","iconPath":"static/tabbar/sale.png","iconWidth":"60px"},"list":[{"pagePath":"pages/home/index","iconPath":"static/tabbar/home.png","selectedIconPath":"static/tabbar/homeActive.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/gameList/index","iconPath":"static/tabbar/buy.png","selectedIconPath":"static/tabbar/buyActive.png","text":"买号","redDot":false,"badge":""},{"pagePath":"pages/conversation/xitongxiaoxi","iconPath":"static/tabbar/msg.png","selectedIconPath":"static/tabbar/msgActive.png","text":"消息","redDot":false,"badge":""},{"pagePath":"pages/mine/index","iconPath":"static/tabbar/mine.png","selectedIconPath":"static/tabbar/mineActive.png","text":"我的","redDot":false,"badge":""}]},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"瓦兰代售-游戏账号交易平台","navigationBarBackgroundColor":"#fff","backgroundColor":"#fff","rpxCalcMaxDeviceWidth":960,"rpxCalcBaseDeviceWidth":375,"rpxCalcIncludeWidth":750,"maxWidth":960}};
global.__uniConfig.compilerVersion = '4.87';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__0BBA027';
global.__uniConfig.appName = '瓦兰代售';
global.__uniConfig.appVersion = 'v1.3.6';
global.__uniConfig.appVersionCode = '136';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "zh-Hans";
global.__uniConfig.fallbackLocale = "zh-Hans";
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/home/index"+'.vue')), 'pages-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/login/index"+'.vue')), 'pages-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/login/register"+'.vue')), 'pages-login-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-collect-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/collect/index"+'.vue')), 'pages-collect-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-noticeList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/noticeList/index"+'.vue')), 'pages-noticeList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-message-datum', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/message/datum"+'.vue')), 'pages-message-datum'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-noticeList-zhaohuiList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/noticeList/zhaohuiList"+'.vue')), 'pages-noticeList-zhaohuiList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-black-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/black/index"+'.vue')), 'pages-black-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-noticeList-noticeDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/noticeList/noticeDetail"+'.vue')), 'pages-noticeList-noticeDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-gameList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/gameList/index"+'.vue')), 'pages-gameList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-gameList-otherGameList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/gameList/otherGameList"+'.vue')), 'pages-gameList-otherGameList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-middleman-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/middleman/index"+'.vue')), 'pages-middleman-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-middleman-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/middleman/detail"+'.vue')), 'pages-middleman-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/goodsList/index"+'.vue')), 'pages-goodsList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsList-shop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/goodsList/shop"+'.vue')), 'pages-goodsList-shop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/detail/index"+'.vue')), 'pages-detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-sureOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/order/sureOrder"+'.vue')), 'pages-order-sureOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-orderDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/order/orderDetail"+'.vue')), 'pages-order-orderDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-kefuCheck-Gfkefu', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/kefuCheck/Gfkefu"+'.vue')), 'pages-kefuCheck-Gfkefu'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-zhongjiedanbao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/home/zhongjiedanbao"+'.vue')), 'pages-home-zhongjiedanbao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-afterSale', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/order/afterSale"+'.vue')), 'pages-order-afterSale'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-afterOrder-afterSaleType', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/afterOrder/afterSaleType"+'.vue')), 'pages-afterOrder-afterSaleType'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-afterOrder-inputInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/afterOrder/inputInfo"+'.vue')), 'pages-afterOrder-inputInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-afterOrder-afterOrderList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/afterOrder/afterOrderList"+'.vue')), 'pages-afterOrder-afterOrderList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-afterOrder-afterOrderInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/afterOrder/afterOrderInfo"+'.vue')), 'pages-afterOrder-afterOrderInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-saleGameList-saleChoose', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/saleGameList/saleChoose"+'.vue')), 'pages-saleGameList-saleChoose'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-saleGameList-guzhi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/saleGameList/guzhi"+'.vue')), 'pages-saleGameList-guzhi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-saleGameList-rggz', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/saleGameList/rggz"+'.vue')), 'pages-saleGameList-rggz'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-retrieveAccount-mySaled-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/retrieveAccount/mySaled/index"+'.vue')), 'pages-retrieveAccount-mySaled-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-retrieveAccount-accountInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/retrieveAccount/accountInfo"+'.vue')), 'pages-retrieveAccount-accountInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-retrieveAccount-gujiaInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/retrieveAccount/gujiaInfo"+'.vue')), 'pages-retrieveAccount-gujiaInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-retrieveAccount-putongInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/retrieveAccount/putongInfo"+'.vue')), 'pages-retrieveAccount-putongInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-myAccount-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/myAccount/index"+'.vue')), 'pages-mine-myAccount-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-conversation-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/conversation/index"+'.vue')), 'pages-conversation-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/index"+'.vue')), 'pages-mine-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-myshezhi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/myshezhi"+'.vue')), 'pages-mine-myshezhi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-myCollect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/myCollect"+'.vue')), 'pages-mine-myCollect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-myHistory', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/myHistory"+'.vue')), 'pages-mine-myHistory'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-jianding', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/jianding"+'.vue')), 'pages-mine-jianding'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-saleGameList-rggzdetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/saleGameList/rggzdetail"+'.vue')), 'pages-saleGameList-rggzdetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-jiandingdetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/jiandingdetail"+'.vue')), 'pages-mine-jiandingdetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-fankui-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/fankui/index"+'.vue')), 'pages-fankui-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-zhuboList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/zhuboList/index"+'.vue')), 'pages-zhuboList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-setting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/setting"+'.vue')), 'pages-mine-setting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-erpInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/mine/erpInfo"+'.vue')), 'pages-mine-erpInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-supplierCommitInfo-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/supplierCommitInfo/index"+'.vue')), 'pages-supplierCommitInfo-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-commitFinace-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/commitFinace/index"+'.vue')), 'pages-commitFinace-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-appdownload', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/home/appdownload"+'.vue')), 'pages-home-appdownload'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notification-notification', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/notification/notification"+'.vue')), 'pages-notification-notification'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notification_friendDetail-friendDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/notification_friendDetail/friendDetail"+'.vue')), 'pages-notification_friendDetail-friendDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chatroom-chatroom', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/chatroom/chatroom"+'.vue')), 'pages-chatroom-chatroom'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-groupChatRoom-groupChatRoom', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/groupChatRoom/groupChatRoom"+'.vue')), 'pages-groupChatRoom-groupChatRoom'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-saleGameList-jisuhuishou', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/saleGameList/jisuhuishou"+'.vue')), 'pages-saleGameList-jisuhuishou'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-homedetails-jiaoyixuzhi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/homedetails/jiaoyixuzhi"+'.vue')), 'pages-homedetails-jiaoyixuzhi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-homedetails-yewujieshao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/homedetails/yewujieshao"+'.vue')), 'pages-homedetails-yewujieshao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-homedetails-pingtaikefu', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/homedetails/pingtaikefu"+'.vue')), 'pages-homedetails-pingtaikefu'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-homedetails-kefuyanzheng', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/homedetails/kefuyanzheng"+'.vue')), 'pages-homedetails-kefuyanzheng'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-homedetails-shipinhao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/homedetails/shipinhao"+'.vue')), 'pages-homedetails-shipinhao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-detail-demo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/detail/demo"+'.vue')), 'pages-detail-demo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-changepassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/changepassword"+'.vue')), 'pages-user-changepassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-bangzhuz', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/bangzhuz"+'.vue')), 'pages-user-bangzhuz'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-lianxikf', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/lianxikf"+'.vue')), 'pages-user-lianxikf'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-shimingrz', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/shimingrz"+'.vue')), 'pages-user-shimingrz'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-guanyuwm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/guanyuwm"+'.vue')), 'pages-user-guanyuwm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-yinsixy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/yinsixy"+'.vue')), 'pages-user-yinsixy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-yonghuxy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/yonghuxy"+'.vue')), 'pages-user-yonghuxy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-yinsixyNoTitle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/yinsixyNoTitle"+'.vue')), 'pages-user-yinsixyNoTitle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-yonghuxyNoTitle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/yonghuxyNoTitle"+'.vue')), 'pages-user-yonghuxyNoTitle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-orderList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/order/orderList"+'.vue')), 'pages-order-orderList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-wentixiangqing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/wentixiangqing"+'.vue')), 'pages-user-wentixiangqing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-chengjiao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/home/chengjiao"+'.vue')), 'pages-home-chengjiao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-maidanxinagqingtiao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/user/maidanxinagqingtiao"+'.vue')), 'pages-user-maidanxinagqingtiao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsList-anlidetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/goodsList/anlidetails"+'.vue')), 'pages-goodsList-anlidetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-conversation-xitongxiaoxi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/conversation/xitongxiaoxi"+'.vue')), 'pages-conversation-xitongxiaoxi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-webView-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/webView/index"+'.vue')), 'pages-webView-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-conversation-xinwengonggao', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/conversation/xinwengonggao"+'.vue')), 'pages-conversation-xinwengonggao'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-conversation-xinwenggdetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/conversation/xinwenggdetails"+'.vue')), 'pages-conversation-xinwenggdetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-paySuccess-paySuccess', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/Users/Administrator/Desktop/项目/瓦兰/h5/pages/paySuccess/paySuccess"+'.vue')), 'pages-paySuccess-paySuccess'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"瓦兰代售-游戏账号交易平台","navigationStyle":"custom","enablePullDownRefresh":false,"onReachBottomDistance":100})
      },
      [
        createElement('pages-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-home-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/home/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/login/index',
  windowTop:0
}
},
{
path: '/pages/login/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-register',
  isNVue:false,maxWidth:960,
  pagePath:'pages/login/register',
  windowTop:44
}
},
{
path: '/pages/collect/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的收藏","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-collect-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-collect-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/collect/index',
  windowTop:44
}
},
{
path: '/pages/noticeList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告列表","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-noticeList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-noticeList-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/noticeList/index',
  windowTop:44
}
},
{
path: '/pages/message/datum',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"填写包赔","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-message-datum', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-message-datum',
  isNVue:false,maxWidth:960,
  pagePath:'pages/message/datum',
  windowTop:44
}
},
{
path: '/pages/noticeList/zhaohuiList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"找回案例","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-noticeList-zhaohuiList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-noticeList-zhaohuiList',
  isNVue:false,maxWidth:960,
  pagePath:'pages/noticeList/zhaohuiList',
  windowTop:44
}
},
{
path: '/pages/black/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"黑号查询","enablePullDownRefresh":false})
      },
      [
        createElement('pages-black-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-black-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/black/index',
  windowTop:44
}
},
{
path: '/pages/noticeList/noticeDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"详情","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-noticeList-noticeDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-noticeList-noticeDetail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/noticeList/noticeDetail',
  windowTop:44
}
},
{
path: '/pages/gameList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要买","navigationStyle":"default","enablePullDownRefresh":false,"onReachBottomDistance":100})
      },
      [
        createElement('pages-gameList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-gameList-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/gameList/index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/gameList/otherGameList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择游戏","navigationStyle":"default","enablePullDownRefresh":false,"onReachBottomDistance":100})
      },
      [
        createElement('pages-gameList-otherGameList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-gameList-otherGameList',
  isNVue:false,maxWidth:960,
  pagePath:'pages/gameList/otherGameList',
  windowTop:44
}
},
{
path: '/pages/middleman/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"中介担保","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-middleman-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-middleman-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/middleman/index',
  windowTop:0
}
},
{
path: '/pages/middleman/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"瓦兰护航 安全有保障","navigationStyle":"default","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#fffafa"})
      },
      [
        createElement('pages-middleman-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-middleman-detail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/middleman/detail',
  windowTop:44
}
},
{
path: '/pages/goodsList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表","navigationStyle":"custom","enablePullDownRefresh":false,"onReachBottomDistance":100})
      },
      [
        createElement('pages-goodsList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsList-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/goodsList/index',
  windowTop:0
}
},
{
path: '/pages/goodsList/shop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表","navigationStyle":"custom","enablePullDownRefresh":false,"onReachBottomDistance":100})
      },
      [
        createElement('pages-goodsList-shop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsList-shop',
  isNVue:false,maxWidth:960,
  pagePath:'pages/goodsList/shop',
  windowTop:0
}
},
{
path: '/pages/detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-detail-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/detail/index',
  windowTop:44
}
},
{
path: '/pages/order/sureOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-order-sureOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-sureOrder',
  isNVue:false,maxWidth:960,
  pagePath:'pages/order/sureOrder',
  windowTop:44
}
},
{
path: '/pages/order/orderDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-order-orderDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-orderDetail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/order/orderDetail',
  windowTop:44
}
},
{
path: '/pages/kefuCheck/Gfkefu',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"官方客服","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-kefuCheck-Gfkefu', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-kefuCheck-Gfkefu',
  isNVue:false,maxWidth:960,
  pagePath:'pages/kefuCheck/Gfkefu',
  windowTop:0
}
},
{
path: '/pages/home/zhongjiedanbao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"中介担保","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-home-zhongjiedanbao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-zhongjiedanbao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/home/zhongjiedanbao',
  windowTop:0
}
},
{
path: '/pages/order/afterSale',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请售后","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-order-afterSale', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-afterSale',
  isNVue:false,maxWidth:960,
  pagePath:'pages/order/afterSale',
  windowTop:44
}
},
{
path: '/pages/afterOrder/afterSaleType',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择售后方式","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-afterOrder-afterSaleType', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-afterOrder-afterSaleType',
  isNVue:false,maxWidth:960,
  pagePath:'pages/afterOrder/afterSaleType',
  windowTop:44
}
},
{
path: '/pages/afterOrder/inputInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请售后","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-afterOrder-inputInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-afterOrder-inputInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/afterOrder/inputInfo',
  windowTop:44
}
},
{
path: '/pages/afterOrder/afterOrderList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退款售后","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-afterOrder-afterOrderList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-afterOrder-afterOrderList',
  isNVue:false,maxWidth:960,
  pagePath:'pages/afterOrder/afterOrderList',
  windowTop:44
}
},
{
path: '/pages/afterOrder/afterOrderInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后详情","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-afterOrder-afterOrderInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-afterOrder-afterOrderInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/afterOrder/afterOrderInfo',
  windowTop:44
}
},
{
path: '/pages/saleGameList/saleChoose',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要卖","navigationStyle":"custom"})
      },
      [
        createElement('pages-saleGameList-saleChoose', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-saleGameList-saleChoose',
  isNVue:false,maxWidth:960,
  pagePath:'pages/saleGameList/saleChoose',
  windowTop:0
}
},
{
path: '/pages/saleGameList/guzhi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账号估值","navigationStyle":"custom"})
      },
      [
        createElement('pages-saleGameList-guzhi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-saleGameList-guzhi',
  isNVue:false,maxWidth:960,
  pagePath:'pages/saleGameList/guzhi',
  windowTop:0
}
},
{
path: '/pages/saleGameList/rggz',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人工估值","navigationStyle":"custom"})
      },
      [
        createElement('pages-saleGameList-rggz', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-saleGameList-rggz',
  isNVue:false,maxWidth:960,
  pagePath:'pages/saleGameList/rggz',
  windowTop:0
}
},
{
path: '/pages/retrieveAccount/mySaled/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的回收","navigationStyle":"default","enablePullDownRefresh":true,"onReachBottomDistance":100})
      },
      [
        createElement('pages-retrieveAccount-mySaled-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-retrieveAccount-mySaled-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/retrieveAccount/mySaled/index',
  windowTop:44
}
},
{
path: '/pages/retrieveAccount/accountInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"官网代售","navigationStyle":"default"})
      },
      [
        createElement('pages-retrieveAccount-accountInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-retrieveAccount-accountInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/retrieveAccount/accountInfo',
  windowTop:44
}
},
{
path: '/pages/retrieveAccount/gujiaInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"填写估值信息","navigationStyle":"custom"})
      },
      [
        createElement('pages-retrieveAccount-gujiaInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-retrieveAccount-gujiaInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/retrieveAccount/gujiaInfo',
  windowTop:0
}
},
{
path: '/pages/retrieveAccount/putongInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"官网代售","navigationStyle":"default"})
      },
      [
        createElement('pages-retrieveAccount-putongInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-retrieveAccount-putongInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/retrieveAccount/putongInfo',
  windowTop:44
}
},
{
path: '/pages/mine/myAccount/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的商品","navigationStyle":"default","enablePullDownRefresh":true,"onReachBottomDistance":100,"titleNView":{"buttons":[{"type":"none","text":"刷新","fontSize":"32rpx","color":"#000000"}]}})
      },
      [
        createElement('pages-mine-myAccount-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-myAccount-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/myAccount/index',
  windowTop:44
}
},
{
path: '/pages/conversation/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"系统消息","navigationStyle":"default"})
      },
      [
        createElement('pages-conversation-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-conversation-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/conversation/index',
  windowTop:44
}
},
{
path: '/pages/mine/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-mine-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/mine/myshezhi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-myshezhi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-myshezhi',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/myshezhi',
  windowTop:44
}
},
{
path: '/pages/mine/myCollect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的收藏","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-myCollect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-myCollect',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/myCollect',
  windowTop:44
}
},
{
path: '/pages/mine/myHistory',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的浏览历史","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-myHistory', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-myHistory',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/myHistory',
  windowTop:44
}
},
{
path: '/pages/mine/jianding',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的鉴定","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-jianding', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-jianding',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/jianding',
  windowTop:44
}
},
{
path: '/pages/saleGameList/rggzdetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-saleGameList-rggzdetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-saleGameList-rggzdetail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/saleGameList/rggzdetail',
  windowTop:44
}
},
{
path: '/pages/mine/jiandingdetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"鉴定结果","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-jiandingdetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-jiandingdetail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/jiandingdetail',
  windowTop:0
}
},
{
path: '/pages/fankui/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"投诉建议","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-fankui-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-fankui-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/fankui/index',
  windowTop:44
}
},
{
path: '/pages/zhuboList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"主播列表","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-zhuboList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-zhuboList-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/zhuboList/index',
  windowTop:0
}
},
{
path: '/pages/mine/setting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资料修改","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-setting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-setting',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/setting',
  windowTop:44
}
},
{
path: '/pages/mine/erpInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商户后台","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mine-erpInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-erpInfo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/mine/erpInfo',
  windowTop:44
}
},
{
path: '/pages/supplierCommitInfo/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"瓦兰代售网络","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-supplierCommitInfo-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-supplierCommitInfo-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/supplierCommitInfo/index',
  windowTop:44
}
},
{
path: '/pages/commitFinace/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"财务录入","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-commitFinace-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-commitFinace-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/commitFinace/index',
  windowTop:44
}
},
{
path: '/pages/home/appdownload',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"APP下载","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-home-appdownload', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-appdownload',
  isNVue:false,maxWidth:960,
  pagePath:'pages/home/appdownload',
  windowTop:44
}
},
{
path: '/pages/notification/notification',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"通知列表","navigationStyle":"default"})
      },
      [
        createElement('pages-notification-notification', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notification-notification',
  isNVue:false,maxWidth:960,
  pagePath:'pages/notification/notification',
  windowTop:44
}
},
{
path: '/pages/notification_friendDetail/friendDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加好友","navigationStyle":"default"})
      },
      [
        createElement('pages-notification_friendDetail-friendDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notification_friendDetail-friendDetail',
  isNVue:false,maxWidth:960,
  pagePath:'pages/notification_friendDetail/friendDetail',
  windowTop:44
}
},
{
path: '/pages/chatroom/chatroom',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"在线聊天","navigationStyle":"custom","enablePullDownRefresh":true})
      },
      [
        createElement('pages-chatroom-chatroom', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chatroom-chatroom',
  isNVue:false,maxWidth:960,
  pagePath:'pages/chatroom/chatroom',
  windowTop:0
}
},
{
path: '/pages/groupChatRoom/groupChatRoom',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"在线聊天","navigationStyle":"custom","enablePullDownRefresh":true})
      },
      [
        createElement('pages-groupChatRoom-groupChatRoom', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-groupChatRoom-groupChatRoom',
  isNVue:false,maxWidth:960,
  pagePath:'pages/groupChatRoom/groupChatRoom',
  windowTop:0
}
},
{
path: '/pages/saleGameList/jisuhuishou',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"极速回收","navigationStyle":"default","enablePullDownRefresh":false})
      },
      [
        createElement('pages-saleGameList-jisuhuishou', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-saleGameList-jisuhuishou',
  isNVue:false,maxWidth:960,
  pagePath:'pages/saleGameList/jisuhuishou',
  windowTop:44
}
},
{
path: '/pages/homedetails/jiaoyixuzhi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"交易须知","enablePullDownRefresh":false})
      },
      [
        createElement('pages-homedetails-jiaoyixuzhi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-homedetails-jiaoyixuzhi',
  isNVue:false,maxWidth:960,
  pagePath:'pages/homedetails/jiaoyixuzhi',
  windowTop:44
}
},
{
path: '/pages/homedetails/yewujieshao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"业务介绍","enablePullDownRefresh":false})
      },
      [
        createElement('pages-homedetails-yewujieshao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-homedetails-yewujieshao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/homedetails/yewujieshao',
  windowTop:44
}
},
{
path: '/pages/homedetails/pingtaikefu',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"平台客服联系方式","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-homedetails-pingtaikefu', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-homedetails-pingtaikefu',
  isNVue:false,maxWidth:960,
  pagePath:'pages/homedetails/pingtaikefu',
  windowTop:0
}
},
{
path: '/pages/homedetails/kefuyanzheng',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客服验证","enablePullDownRefresh":false})
      },
      [
        createElement('pages-homedetails-kefuyanzheng', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-homedetails-kefuyanzheng',
  isNVue:false,maxWidth:960,
  pagePath:'pages/homedetails/kefuyanzheng',
  windowTop:44
}
},
{
path: '/pages/homedetails/shipinhao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"官方视频号","enablePullDownRefresh":false})
      },
      [
        createElement('pages-homedetails-shipinhao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-homedetails-shipinhao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/homedetails/shipinhao',
  windowTop:44
}
},
{
path: '/pages/detail/demo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"官方交易群","enablePullDownRefresh":false})
      },
      [
        createElement('pages-detail-demo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-detail-demo',
  isNVue:false,maxWidth:960,
  pagePath:'pages/detail/demo',
  windowTop:44
}
},
{
path: '/pages/user/changepassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-changepassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-changepassword',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/changepassword',
  windowTop:44
}
},
{
path: '/pages/user/bangzhuz',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"帮助中心","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-bangzhuz', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-bangzhuz',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/bangzhuz',
  windowTop:44
}
},
{
path: '/pages/user/lianxikf',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"联系客服","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-lianxikf', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-lianxikf',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/lianxikf',
  windowTop:44
}
},
{
path: '/pages/user/shimingrz',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"实名认证","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-shimingrz', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-shimingrz',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/shimingrz',
  windowTop:44
}
},
{
path: '/pages/user/guanyuwm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-guanyuwm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-guanyuwm',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/guanyuwm',
  windowTop:44
}
},
{
path: '/pages/user/yinsixy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私协议","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-yinsixy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-yinsixy',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/yinsixy',
  windowTop:44
}
},
{
path: '/pages/user/yonghuxy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户协议","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-yonghuxy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-yonghuxy',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/yonghuxy',
  windowTop:44
}
},
{
path: '/pages/user/yinsixyNoTitle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私协议","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-user-yinsixyNoTitle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-yinsixyNoTitle',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/yinsixyNoTitle',
  windowTop:0
}
},
{
path: '/pages/user/yonghuxyNoTitle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户协议","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-user-yonghuxyNoTitle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-yonghuxyNoTitle',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/yonghuxyNoTitle',
  windowTop:0
}
},
{
path: '/pages/order/orderList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的买单","enablePullDownRefresh":true})
      },
      [
        createElement('pages-order-orderList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-orderList',
  isNVue:false,maxWidth:960,
  pagePath:'pages/order/orderList',
  windowTop:44
}
},
{
path: '/pages/user/wentixiangqing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"问题详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-wentixiangqing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-wentixiangqing',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/wentixiangqing',
  windowTop:44
}
},
{
path: '/pages/home/chengjiao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"最近成交","enablePullDownRefresh":false})
      },
      [
        createElement('pages-home-chengjiao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-chengjiao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/home/chengjiao',
  windowTop:44
}
},
{
path: '/pages/user/maidanxinagqingtiao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":" 卖单详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-maidanxinagqingtiao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-maidanxinagqingtiao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/user/maidanxinagqingtiao',
  windowTop:44
}
},
{
path: '/pages/goodsList/anlidetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"案例详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-goodsList-anlidetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsList-anlidetails',
  isNVue:false,maxWidth:960,
  pagePath:'pages/goodsList/anlidetails',
  windowTop:44
}
},
{
path: '/pages/conversation/xitongxiaoxi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息","enablePullDownRefresh":false,"navigationStyle":"default"})
      },
      [
        createElement('pages-conversation-xitongxiaoxi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-conversation-xitongxiaoxi',
  isNVue:false,maxWidth:960,
  pagePath:'pages/conversation/xitongxiaoxi',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/webView/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"瓦兰代售","enablePullDownRefresh":false})
      },
      [
        createElement('pages-webView-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-webView-index',
  isNVue:false,maxWidth:960,
  pagePath:'pages/webView/index',
  windowTop:44
}
},
{
path: '/pages/conversation/xinwengonggao',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新闻公告","enablePullDownRefresh":false})
      },
      [
        createElement('pages-conversation-xinwengonggao', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-conversation-xinwengonggao',
  isNVue:false,maxWidth:960,
  pagePath:'pages/conversation/xinwengonggao',
  windowTop:44
}
},
{
path: '/pages/conversation/xinwenggdetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-conversation-xinwenggdetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-conversation-xinwenggdetails',
  isNVue:false,maxWidth:960,
  pagePath:'pages/conversation/xinwenggdetails',
  windowTop:44
}
},
{
path: '/pages/paySuccess/paySuccess',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-paySuccess-paySuccess', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-paySuccess-paySuccess',
  isNVue:false,maxWidth:960,
  pagePath:'pages/paySuccess/paySuccess',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
